import ListItem from '@mui/material/ListItem';
import {useSidebarContext} from 'main/utility/AppContextProvider/SidebarContextProvider';
import PropsTypes from 'prop-types';
import {Fonts} from 'shared/constants/AppEnums';

const VerticalCollapseItem = ({children, ...rest}) => {
  const {sidebarTextColor, sidebarMenuHoverTextColor} = useSidebarContext();

  return (
    <ListItem
      sx={{
        height: 40,
        my: 0.25,
        pl: '31px',
        pr: 3.75,
        whiteSpace: 'nowrap',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        letterSpacing: '0.5px',
        '& .nav-item-text': {
          fontWeight: Fonts.MEDIUM,
          color: sidebarTextColor,
        },

        '& .nav-item-icon': {
          color: sidebarTextColor,
          fontSize: 20,
          display: 'block',
        },

        '& .nav-item-icon-arrow': {
          color: sidebarTextColor,
        },

        '& .MuiIconButton-root': {
          mr: 3,
          padding: 0,
        },

        '& .MuiTouchRipple-root': {
          zIndex: 10,
        },

        '&.open, &:hover, &:focus': {
          '& .nav-item-text': {
            fontWeight: Fonts.MEDIUM,
            color: sidebarMenuHoverTextColor,
          },

          '& .nav-item-icon': {
            color: sidebarMenuHoverTextColor,
          },

          '& .nav-item-icon-arrow': {
            color: sidebarMenuHoverTextColor,
          },
        },
        '&:hover': {
          backgroundColor: 'transparent',
        },
      }}
      {...rest}
    >
      {children}
    </ListItem>
  );
};

export default VerticalCollapseItem;

VerticalCollapseItem.propTypes = {
  children: PropsTypes.node,
};
